import { AccessEntries } from "../utils/accessEntries";
import { ReactNode } from "react";
import { useSelector } from "react-redux";
import { userRightsSelector } from "../redux/setting";

type Props = {
  entry: AccessEntries;
  children: ReactNode;
  accessValues?: string[] | string;
  noAccessMessage?: ReactNode;
};

export function Access({ entry, children, noAccessMessage = null, accessValues }: Props) {
  const accessRights = useSelector(userRightsSelector);
  const level = accessRights?.[entry]?.AccessLevel;
  if (Array.isArray(accessValues) ? accessValues.includes(level) : accessValues === level) {
    return <>{children}</>;
  }
  return <>{noAccessMessage}</>;
}
